<template>
  <g
    id="ic_course_headphone"
    transform="translate(6 -2)"
  >
    <path
      id="Pfad_1026"
      data-name="Pfad 1026"
      d="M0,0H24V24H0Z"
      transform="translate(-6 2)"
      fill="none"
      opacity="0.87"
    />
    <g
      id="Gruppe_888"
      data-name="Gruppe 888"
      transform="translate(-3 5)"
    >
      <g
        id="Gruppe_886"
        data-name="Gruppe 886"
        transform="translate(0.273)"
      >
        <path
          id="Pfad_1062"
          data-name="Pfad 1062"
          d="M23.708,18.695V15.166a9.491,9.491,0,0,0-2.63-6.66,8.625,8.625,0,0,0-6.35-2.759,9.217,9.217,0,0,0-8.981,9.419v3.5a5.484,5.484,0,0,1,1.422-3.231v-.273a7.755,7.755,0,0,1,7.559-7.928,7.371,7.371,0,0,1,5.355,2.311,8.072,8.072,0,0,1,2.2,5.616v.248a5.484,5.484,0,0,1,1.422,3.231Z"
          transform="translate(-5.747 -5.747)"
          fill="#6e7989"
        />
        <path
          id="Pfad_1063"
          data-name="Pfad 1063"
          d="M36.6,280.033h0v.05a2.01,2.01,0,0,0-.025.4v.273H36.6Z"
          transform="translate(-35.106 -266.986)"
          fill="#6e7989"
        />
        <path
          id="Pfad_1064"
          data-name="Pfad 1064"
          d="M370.416,279.586v.671h.025v-.3A1.529,1.529,0,0,0,370.416,279.586Z"
          transform="translate(-353.946 -266.489)"
          fill="#6e7989"
        />
      </g>
      <g
        id="Gruppe_887"
        data-name="Gruppe 887"
        transform="translate(0 7.986)"
      >
        <path
          id="Pfad_1065"
          data-name="Pfad 1065"
          d="M.025,181.932a3.852,3.852,0,0,0-.025.522A5.223,5.223,0,0,0,5.095,187.8a.732.732,0,0,0,.746-.746v-9.2a.732.732,0,0,0-.746-.745,4.9,4.9,0,0,0-3.579,1.541,5.368,5.368,0,0,0-1.491,3.231Z"
          transform="translate(0 -177.061)"
          fill="#35bc9e"
        />
        <path
          id="Pfad_1066"
          data-name="Pfad 1066"
          d="M290.55,180.912v-.075a5.367,5.367,0,0,0-1.491-3.231,5,5,0,0,0-3.579-1.541.732.732,0,0,0-.745.746v9.2a.732.732,0,0,0,.745.746,5.223,5.223,0,0,0,5.095-5.343A3.5,3.5,0,0,0,290.55,180.912Z"
          transform="translate(-272.067 -176.066)"
          fill="#35bc9e"
        />
      </g>
    </g>
  </g>
</template>
